'use strict';

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
module.exports = {
  methods: {
    afterApplePayTagReplacement: function afterApplePayTagReplacement(data) {
      var checkoutPaymentTab = $('.nav-item.applepay-tab-wrapper');
      if (checkoutPaymentTab.length === 1) {
        checkoutPaymentTab.removeAttr('hidden');
      }
      var container;
      if (data && data.target) {
        container = $(data.target).find('.js-paymentmethodwarning-msgcontainer');
      } else {
        container = $('#applepay-content .js-paymentmethodwarning-msgcontainer');
      }
      if (container) {
        container.attr('data-iframepresent', true);
        container.data('iframepresent', true);
        $('body').trigger('PaymentMethodObserver:iframePresent');
      }
    }
  },
  updateAddToCart: function updateAddToCart() {
    $('body').on('product:updateAddToCart', function (e, response) {
      var $productContainer = response.$productContainer;
      var appleButton = $productContainer.find('button.dw-apple-pay-button');
      if (appleButton && appleButton.length) {
        $('body').trigger('PaymentMethodObserver:Show', {
          name: 'available',
          show: !response.product.readyToOrder || !response.product.available
        });
        appleButton.attr('sku', response.product.id);
      }
    });
  },
  detectIsApplePayTagReplacement: function detectIsApplePayTagReplacement() {
    //can handle running before or after replacement by internal demandware applepay script
    var applePayTag = $('isapplepay');
    if (applePayTag.length === 0) {
      module.exports.methods.afterApplePayTagReplacement();
    } else {
      $('body').on('PaymentMethodObserver:AddNode', function (e, data) {
        if (data && data.addNode && data.addNode.classList) {
          var _iterator = _createForOfIteratorHelper(data.addNode.classList),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var className = _step.value;
              if (className === 'dw-apple-pay-button') {
                module.exports.methods.afterApplePayTagReplacement(data);
                data.observer.disconnect();
                return;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      });
    }
  }
};